<script lang="ts">
	// Import common notifications component
	import Notifications from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/Notifications.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<Notifications {device} />
